import React from "react";
import { Puff } from "react-loader-spinner";

export default function Loader() {
	return (
		<div className="loader">
			<Puff color="#00BFFF" height={100} width={100} radius={500} />
		</div>
	);
}
